import { render, staticRenderFns } from "./ConfirmBtn.vue?vue&type=template&id=6466e332&scoped=true&"
import script from "./ConfirmBtn.vue?vue&type=script&lang=js&"
export * from "./ConfirmBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466e332",
  null
  
)

export default component.exports